<template>
  <div class="certification-staus">
    <span :class="typeName().className" />
    {{ typeName().name }}
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: () => 'Unknown',
    },
  },
  methods: {
    typeName() {
      const statusColor = [
        { id: 0, name: 'Unknown' },
        { id: 1, name: 'Issued', className: 'Issued' },
        { id: 2, name: 'Renewed', className: 'Renewed' },
        { id: 3, name: 'Pending validation', className: 'Pending-validation' },
        { id: 4, name: 'Inactive', className: 'Inactive' },
        { id: 5, name: 'Expired', className: 'Expired' },
        { id: 6, name: 'Revoked', className: 'Revoked' },
        { id: 7, name: 'Failed', className: 'Failed' },
        { id: 8, name: 'TimedOut', className: 'TimedOut' },
        { id: 9, name: 'Auto Validating', className: 'Auto-Validating' },
      ]
      const status = statusColor.find(item => item.name === this.type)

      if (status) {
        return status
      }
      return { id: 0, name: 'Unknown', className: '' }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";
.certification-staus {
  display: flex;
  align-items: center;

  span {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 4px;
    margin-top: 1px;
    background-color: $gray;

    &.Issued {
      background-color: $green;
    }
    &.Renewed {
      background-color: $green;
    }
    &.Pending-validation {
      background-color: $orange;
    }
    &.Inactive {
      background-color: $orange;
    }
    &.Expired {
      background-color:  $red;
    }
    &.Revoked {
      background-color: $red;
    }
    &.Failed {
      background-color: $red;
    }
    &.TimedOut {
      background-color: $red;
    }
    &.Auto-Validating {
      background-color: $orange;
    }
  }
}
</style>
